export enum invoicesState {
  pending = 1,
  expired = 2,
  partiallyPaid = 3,
  paid = 4,
  cancelled = 5,
}
